import Debug from "debug";

import { ACTIONS } from "./constants";
import {
  PayloadStudioGetTokenSuccess,
  PayloadStudioGetTokenFailure,
  PayloadStudioGetTokenRequest,
  PayloadStudioToken,
} from "../types";

const debug = Debug("broadcast:actions:studio");

export const requestStudioToken = (
  payload: PayloadStudioToken
): PayloadStudioGetTokenRequest => {
  debug("requestStudioToken");
  return {
    type: ACTIONS.STUDIO_TOKEN_REQUEST,
    payload,
  };
};

export const receivedStudioToken = (
  payload: string
): PayloadStudioGetTokenSuccess => {
  debug("receivedStudioToken", payload);
  return {
    type: ACTIONS.STUDIO_TOKEN_SUCCESS,
    payload,
  };
};

export const failedStudioToken = (payload: {
  [key: string]: string;
}): PayloadStudioGetTokenFailure => {
  debug("failedStudioToken", payload);
  return {
    type: ACTIONS.STUDIO_TOKEN_FAILURE,
    payload,
  };
};
